import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col justify-center items-center text-gray-700 p-6",
  align: "center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = {
  key: 1,
  type: "button",
  class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow",
  disabled: ""
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "animate-spin material-icons text-lg text-op-teal mr-2" }, "schedule", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "fixed z-20 .text-justify" }
const _hoisted_7 = { class: "flex flex-col inset-x-0 justify-start text-gray-700 font-bold" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = { class: "text-sm m-2" }
const _hoisted_10 = { class: "fixed z-20 inset-x-0 bottom-0 w-4/5 place-self-center p-8" }
const _hoisted_11 = {
  ref: "mapRef",
  class: "nouns-map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_EventSelector = _resolveComponent("EventSelector")!
  const _component_PhotoPlayback = _resolveComponent("PhotoPlayback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.photoLocal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_InputText, {
            label: "label.name",
            testId: "photo_title",
            text: _ctx.photoTitle,
            "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.photoTitle) = $event))
          }, null, 8, ["text"]),
          _createVNode(_component_EventSelector, {
            eventId: _ctx.eventId,
            "onUpdate:eventId": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eventId) = $event))
          }, null, 8, ["eventId"]),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("message.selectPhotoLocation")), 1),
            _hoisted_2,
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("message.spotPrivacyLevel")) + " : ", 1),
            _withDirectives(_createElementVNode("input", {
              type: "range",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pLevel) = $event)),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.locationUpdated && _ctx.locationUpdated(...args))),
              min: "0",
              max: "100"
            }, null, 544), [
              [_vModelText, _ctx.pLevel]
            ])
          ]),
          (!_ctx.processing)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadPhoto && _ctx.uploadPhoto(...args))),
                id: "UploadImage",
                class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              }, _toDisplayString(_ctx.$t("message.uploadImage")), 1))
            : (_openBlock(), _createElementBlock("button", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.processing")), 1)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_EventSelector, {
                testId: "viewEventSelect",
                eventId: _ctx.viewEventId,
                "onUpdate:eventId": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.viewEventId) = $event))
              }, null, 8, ["eventId"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("label.showPhoto")) + ":", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "showPicture",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShowPicture) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isShowPicture]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_PhotoPlayback, {
              total: _ctx.pinsCount,
              wait: _ctx.playbackConfig.wait,
              title: _ctx.playingTitle,
              onUpdated: _ctx.playbackUpdate,
              onStopped: _ctx.playbackStop,
              ref: "playbackRef"
            }, null, 8, ["total", "wait", "title", "onUpdated", "onStopped"])
          ])
        ])),
    _createElementVNode("div", _hoisted_11, null, 512)
  ], 64))
}